import { LOCALSTORAGE_KEY_BH_TRACKING_CONTEXT } from '../../constants'

export const afterCheckoutSuccess = async ({ order, getLocalStorageByGroup, setLocalStorageByGroup }) => {
	const value = getLocalStorageByGroup(LOCALSTORAGE_KEY_BH_TRACKING_CONTEXT)

	if (!value) {
		return
	}

	// remove all value[sku] that are in order.items
	const newContextValue = { ...value }
	Object.keys(value).forEach((sku) => {
		if (order.items.find((item) => item.sku === sku)) {
			delete newContextValue[sku]
		}
	})

	setLocalStorageByGroup(
		LOCALSTORAGE_KEY_BH_TRACKING_CONTEXT,
		newContextValue,
		new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
	)
}
